/**
 * @fileoverview gRPC-Web generated client stub for com.mu.favorites.api
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


import * as grpcWeb from 'grpc-web';

import {
  AddFavoritesRequest,
  AddFavoritesResponse,
  DeleteFavoritesRequest,
  DeleteFavoritesResponse,
  EditFavoritesRequest,
  EditFavoritesResponse,
  GetFavoriteRequest,
  GetFavoriteResponse,
  GetFavoritesRequest,
  GetFavoritesResponse} from './favorites.api_pb';

export class FavoritesControllerClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: string; };

  constructor (hostname: string,
               credentials: null | { [index: string]: string; },
               options: null | { [index: string]: string; }) {
    if (!options) options = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname;
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodInfoGetFavorites = new grpcWeb.AbstractClientBase.MethodInfo(
    GetFavoritesResponse,
    (request: GetFavoritesRequest) => {
      return request.serializeBinary();
    },
    GetFavoritesResponse.deserializeBinary
  );

  getFavorites(
    request: GetFavoritesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: GetFavoritesResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/com.mu.favorites.api.FavoritesController/GetFavorites',
      request,
      metadata || {},
      this.methodInfoGetFavorites,
      callback);
  }

  methodInfoDeleteFavorites = new grpcWeb.AbstractClientBase.MethodInfo(
    DeleteFavoritesResponse,
    (request: DeleteFavoritesRequest) => {
      return request.serializeBinary();
    },
    DeleteFavoritesResponse.deserializeBinary
  );

  deleteFavorites(
    request: DeleteFavoritesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: DeleteFavoritesResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/com.mu.favorites.api.FavoritesController/DeleteFavorites',
      request,
      metadata || {},
      this.methodInfoDeleteFavorites,
      callback);
  }

  methodInfoAddFavorites = new grpcWeb.AbstractClientBase.MethodInfo(
    AddFavoritesResponse,
    (request: AddFavoritesRequest) => {
      return request.serializeBinary();
    },
    AddFavoritesResponse.deserializeBinary
  );

  addFavorites(
    request: AddFavoritesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: AddFavoritesResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/com.mu.favorites.api.FavoritesController/AddFavorites',
      request,
      metadata || {},
      this.methodInfoAddFavorites,
      callback);
  }

  methodInfoEditFavorites = new grpcWeb.AbstractClientBase.MethodInfo(
    EditFavoritesResponse,
    (request: EditFavoritesRequest) => {
      return request.serializeBinary();
    },
    EditFavoritesResponse.deserializeBinary
  );

  editFavorites(
    request: EditFavoritesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: EditFavoritesResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/com.mu.favorites.api.FavoritesController/EditFavorites',
      request,
      metadata || {},
      this.methodInfoEditFavorites,
      callback);
  }

  methodInfoGetFavorite = new grpcWeb.AbstractClientBase.MethodInfo(
    GetFavoriteResponse,
    (request: GetFavoriteRequest) => {
      return request.serializeBinary();
    },
    GetFavoriteResponse.deserializeBinary
  );

  getFavorite(
    request: GetFavoriteRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.Error,
               response: GetFavoriteResponse) => void) {
    return this.client_.rpcCall(
      this.hostname_ +
        '/com.mu.favorites.api.FavoritesController/GetFavorite',
      request,
      metadata || {},
      this.methodInfoGetFavorite,
      callback);
  }

}

